import { ReactElement } from "react";
import { Grid, Typography, Slider } from "@material-ui/core";
import { debounce } from "throttle-debounce";
import { Controller, useForm } from "react-hook-form";
import CobeeTextField from "app/components/CobeeTextField";
import { ReactComponent as SliderArrows } from "assets/icons/slider-arrows.svg";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";
import parentStyles from "../../styles";
import useStyles from "./styles";

export default function RowEmployeeVat({
  initialValue,
  handleChange,
}: {
  initialValue: number;
  handleChange(e: string): void;
}): ReactElement {
  const { secondColumn } = parentStyles();
  const { containerSlider } = useStyles();

  const { setValue, control } = useForm({
    defaultValues: {
      employee: initialValue,
      company: 100 - initialValue,
      slider: initialValue,
    },
  });

  const handleChangeSlider = debounce(100, false, (newValue) => {
    setValue("employee", newValue);
    setValue("company", 100 - newValue);
    handleChange(newValue);
  });

  const getParseValue = (event) => {
    const {
      target: { value },
    } = event;
    let parsedValue = value !== "" ? value : 0;
    if (parsedValue > 100) {
      parsedValue = 100;
    }

    return parsedValue;
  };

  const updateValues = (parsedValue, field) => {
    setValue("slider", field === "employee" ? 100 - parsedValue : parsedValue);
    setValue(field, 100 - parsedValue);
    handleChange(field === "employee" ? 100 - parsedValue : parsedValue);
  };

  const CobeeSlider = (props) => {
    return (
      <span {...props}>
        <SliderArrows />
      </span>
    );
  };

  return (
    <>
      <Grid item xs={6} container alignItems="center">
        <Typography variant="body2">
          {t(
            "recurrent-payments-section.percentage-of-vat-paid-by-the-employee"
          )}
          :
        </Typography>
      </Grid>
      <Grid item xs={6} className={secondColumn}>
        <Grid container alignItems="center">
          <Grid item xs={2}>
            <Controller
              render={({ onChange, value }) => (
                <CobeeTextField
                  type="number"
                  minWidth={50}
                  min={0}
                  max={100}
                  variant="outlined"
                  styleType="default"
                  step="1"
                  label={t("common-messages.company")}
                  value={value}
                  onChange={(e) => {
                    const parsedValue = getParseValue(e);
                    onChange(parsedValue);
                    if (parsedValue !== "") {
                      updateValues(parsedValue, "employee");
                    }
                  }}
                />
              )}
              name="company"
              control={control}
            />
          </Grid>
          <Grid container alignItems="center" className={containerSlider}>
            <Controller
              render={({ onChange, value }) => (
                <Slider
                  value={Number(value)}
                  min={0}
                  max={100}
                  defaultValue={Number(initialValue)}
                  onChange={(_event, newValue) => {
                    onChange(newValue);
                    handleChangeSlider(newValue);
                  }}
                  ThumbComponent={CobeeSlider}
                />
              )}
              name="slider"
              control={control}
            />
          </Grid>

          <Grid item xs={2}>
            <Controller
              render={({ onChange, value }) => (
                <CobeeTextField
                  type="number"
                  minWidth={50}
                  min={0}
                  max={100}
                  variant="outlined"
                  styleType="default"
                  step="1"
                  label={t("common-messages.employee")}
                  onChange={(e) => {
                    const parsedValue = getParseValue(e);
                    onChange(parsedValue);
                    if (parsedValue !== "") {
                      updateValues(parsedValue, "company");
                    }
                  }}
                  value={value}
                />
              )}
              name="employee"
              control={control}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
